import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    useRouteMatch,
    useHistory,
    Switch,
    Route,
    useLocation,
    Redirect,
} from "react-router-dom";

import {
    fetchUsersAsync,
    fetchContractsAsync,
    fetchTokensAsync,
    setMasterContract,
} from "../store/actions/admin";

import User from "./User";
import Token from "./Token";

import { Box } from "@mui/material";
import UsersList from "../components/Administration/AdminUsers";
import BreadCrumbs from "../components/Breadcrumbs";
import { Input, Label, Card, CardBody } from "reactstrap";
import AdminContracts from "../components/Administration/AdminMasterContract/AdminContracts";
import AdminSales from "../components/Administration/AdminSales/";
import AdminAccess from "../components/Administration/AdminAccess/AdminAccess";
import AdminMasterContractDeploy from "../components/Administration/AdminMasterContract/AdminMasterContractDeploy";
import AdminMasterContractData from "../components/Administration/AdminMasterContract/AdminMasterContractData";

function Administration() {
    const dispatch = useDispatch();
    const history = useHistory();
    const { contracts, tokens, users } = useSelector((state) => state.admin);
    const { url } = useRouteMatch();
    const { pathname } = useLocation();

    useEffect(() => {
        dispatch(fetchUsersAsync());
        dispatch(fetchContractsAsync());
        dispatch(setMasterContract());
        dispatch(fetchTokensAsync());
    }, [dispatch]);

    if (!contracts || !tokens || !users) {
        return <Box></Box>;
    }

    return (
        <Box
            maxWidth="lg"
            sx={{
                minHeight: "78vh",
                margin: "0 auto",
                width: "100%",
            }}
        >
            <BreadCrumbs
                breadCrumbTitle="Administration"
                crumbs={pathname.split("/")}
            />
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "nowrap",
                    minHeight: "60vh",
                }}
            >
                <div className="sidebar-detached sidebar-left">
                    <div className="sidebar">
                        <div>
                            <Card>
                                <CardBody>
                                    <div id="product-categories">
                                        <h5 className="filter-title">Menu</h5>
                                        <Box
                                            component="ul"
                                            className="list-unstyled categories-list"
                                            sx={{
                                                padding: "0",
                                                fontFamily: "Montserrat",
                                                fontWeight: 700,
                                                fontSize: "1.25rem",
                                            }}
                                        >
                                            <li key="users">
                                                <Input
                                                    type="radio"
                                                    id="users"
                                                    name="admin-radio"
                                                    className="me-2"
                                                    defaultChecked={true}
                                                    onClick={() =>
                                                        history.push(
                                                            `${url}/users`
                                                        )
                                                    }
                                                />
                                                <Label
                                                    className="form-check-label"
                                                    for="users"
                                                >
                                                    Users
                                                </Label>
                                            </li>
                                            <li key="contracts">
                                                <Input
                                                    type="radio"
                                                    id="contracts"
                                                    name="admin-radio"
                                                    className="me-2"
                                                    onClick={() =>
                                                        history.push(
                                                            `${url}/contracts`
                                                        )
                                                    }
                                                />
                                                <Label
                                                    className="form-check-label"
                                                    for="contracts"
                                                >
                                                    Contracts
                                                </Label>
                                            </li>
                                            <li key="sales">
                                                <Input
                                                    type="radio"
                                                    id="sales"
                                                    name="admin-radio"
                                                    className="me-2"
                                                    onClick={() =>
                                                        history.push(
                                                            `${url}/sales`
                                                        )
                                                    }
                                                />
                                                <Label
                                                    className="form-check-label"
                                                    for="sales"
                                                >
                                                    Sales
                                                </Label>
                                            </li>
                                            <li key="access">
                                                <Input
                                                    type="radio"
                                                    id="access"
                                                    name="admin-radio"
                                                    className="me-2"
                                                    onClick={() =>
                                                        history.push(
                                                            `${url}/access`
                                                        )
                                                    }
                                                />
                                                <Label
                                                    className="form-check-label"
                                                    for="access"
                                                >
                                                    Access
                                                </Label>
                                            </li>
                                        </Box>
                                    </div>
                                </CardBody>
                            </Card>
                        </div>
                    </div>
                </div>
                <Switch>
                    <Route path={`${url}/users`} exact>
                        <UsersList />
                    </Route>
                    <Route path={`${url}/users/:userId`} exact>
                        <User />
                    </Route>
                    <Route path={`${url}/contracts`} exact>
                        <AdminContracts />
                    </Route>
                    <Route path={`${url}/contracts/master-new/`} exact>
                        <Redirect to={`${url}/contracts`} />
                    </Route>
                    <Route path={`${url}/contracts/master-upgrade/`} exact>
                        <Redirect to={`${url}/contracts`} />
                    </Route>
                    <Route path={`${url}/contracts/:contractID`} exact>
                        <AdminMasterContractData />
                    </Route>
                    <Route
                        path={`${url}/contracts/master-new/:contractType`}
                        exact
                    >
                        <AdminMasterContractDeploy />
                    </Route>
                    <Route
                        path={`${url}/contracts/master-upgrade/:contractId`}
                        exact
                    >
                        <AdminMasterContractDeploy />
                    </Route>
                    <Route path={`${url}/sales`}>
                        <AdminSales />
                    </Route>
                    <Route path={`${url}/access`} exact>
                        <AdminAccess />
                    </Route>
                    <Route path={`${url}/tokens/:tokenId`} exact>
                        <Token />
                    </Route>
                    <Route path="*">
                        <Redirect to={`${url}/users`} />
                    </Route>
                </Switch>
            </Box>
        </Box>
    );
}

export default Administration;
